// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper__2jUyN","box":"Error_box__1A9Zz"};